import React from "react";
import {css, useTheme} from "@emotion/react";

import {Apla} from "@pg-design/apla-module";
import {backgroundColor, borderRadius, color, display, mb, onDesktop, p} from "@pg-design/helpers-css";
import {IPictureSource, Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {ArticleCategory} from "../../actions/ArticleCategory";
import {ArticleContainer} from "../ArticleContainer";
import {getSeeMoreArticleCategories} from "./get_see_more_article_categories";

interface IProps {
    className?: string;
    categories: (ArticleCategory.Taxes | ArticleCategory.Reports | ArticleCategory.Finance)[];
}

export const SeeMoreCategories = (props: IProps) => {
    const theme = useTheme();
    const categories = getSeeMoreArticleCategories(props.categories);

    const numberOfItems = categories.length;

    return (
        <div className={props.className} css={[backgroundColor(theme.colors.info), p(4, 0, 4, 0)]}>
            <ArticleContainer>
                <Text css={[mb(4), onDesktop(mb(5))]} variant="headline_2" as="div">
                    Zobacz więcej w dedykowanych sekcjach
                </Text>

                <div css={categoryListing}>
                    {categories.map((category) => (
                        <AplaCard {...category} key={category.key} useHDImage={numberOfItems === 2} />
                    ))}
                </div>
            </ArticleContainer>
        </div>
    );
};

interface IAplaCardProps {
    url: string;
    titleText: string;
    sources: IPictureSource[];
    useHDImage: boolean;
}

const AplaCard = (props: IAplaCardProps) => {
    const {useHDImage, sources, titleText, url} = props;
    const target = useResponsiveLinkTarget();

    return (
        <a css={[display("inline-block")]} href={url} target={target}>
            <Apla css={apla} applyOn={<Picture sources={useHDImage ? sources : [sources[0]]} alt={titleText} />}>
                <Text css={title} align="center" color="#fff" variant="headline_3" as="div">
                    {titleText}
                </Text>
            </Apla>
        </a>
    );
};
const categoryListing = css`
    display: flex;
    flex-direction: column;
    row-gap: 2.4rem;
    text-align: center;
    ${onDesktop(css`
        justify-content: space-between;
        flex-direction: row;
        column-gap: 2.4rem;
    `)};
`;

const apla = css`
    overflow: hidden;
    position: relative;

    ${borderRadius(2)};
    ${display("inline-block")};
    ${color("#fff")};
`;

const title = css`
    position: absolute;
    bottom: 1.6rem;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
`;
